import Table from "react-bootstrap/Table";
import React from "react";

export const UiTable = (props) => {
    const theader = props.tableHeader;
    return (
        <Table striped  className={`${props.className || ''} ${
            props.removeStripedBg ? 'table--no-stripe-bg' : ''
        }`} >
            <thead>
                <tr>
                    {theader?.map((thItem, index) => (
                        <th key={index} className={`table-th-cls ${thItem.className || ''}`}>{thItem.th}</th>
                    ))}
                </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </Table>
    );
};
